<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="900px"
    transition="dialog-transition"
  >
    <template #activator="{}">
      <v-btn :loading="loading" @click="OpenDialog" icon color="success">
        <v-icon>fas fa-info-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-data-table :headers="head" :items="Transactions" :loading="loading">
        <template v-slot:top>
          <v-toolbar flat color="grey lighten-4">
            <v-toolbar-title>{{ Info.Reason }}</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>
            <!-- <div class="flex-grow-1"></div> -->

            <v-spacer></v-spacer>
            <div>
              <cashDisplay
                :isloading="loading"
                :Balance="TotalAmount"
              ></cashDisplay>
            </div>
          </v-toolbar>
        </template>
        <template v-slot:[`item.deposit`]="{ item }">
          <slot name="deposit" :row="item">
            <template v-if="item.Acc == 'Dr'">
              {{ Math.abs(item.Amount).toLocaleString() }}
              <strong>{{ item.AmountType | MoneySigns }}</strong>
            </template>
          </slot>
        </template>
        <template v-slot:[`item.withdraw`]="{ item }">
          <slot name="withdraw" :row="item">
            <template v-if="item.Acc == 'Cr'">
              {{ Math.abs(item.Amount).toLocaleString() }}
              <strong>{{ item.AmountType | MoneySigns }}</strong>
            </template>
          </slot>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
// import cashDisplay from "@/components/displayCash.vue";
// import axios from "axios";
export default {
  components: {
    cashDisplay: () => import("@/components/util/displayCash.vue"),
  },
  props: {
    // TotalCash: { type: Array, default: () => [] },
    Info: { type: Object, required: true },
    BaseUrl: { type: String, required: true },
    Title: { type: String, default: "" },
    head: {
      type: Array,
      default: () => [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "OUT", value: "deposit" },
        { text: "IN", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
      ],
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      Transactions: [],
      TotalCash: [],
    };
  },
  computed: {
    TotalAmount() {
      return [
        {
          Amount: this.Info.Amount * -1,
          AmountType: this.Info.AmountType,
        },
      ];
    },
  },
  methods: {
    TranSactions() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: `${this.BaseUrl}/transactions`,
        query: {
          _id: this.Info._id,
          Reason: this.Info.Reason,
        },
      });
    },
    OpenDialog() {
      // console.log(this.Info, this.BaseUrl);
      this.loading = true;
      this.TranSactions()
        .then(val => {
          this.loading = false;
          this.dialog = true;
          // console.log(val);
          this.Transactions = val.data;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
